<template>
  <label class="checkbox-container">{{ title }}
    <input type="checkbox" :disabled="disabled" :checked="value" class="widget_checkbox" @change="onChange" />
    <span class="checkmark"></span>
  </label>
</template>

<script>
export default {
  name: "widget_checkbox",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Boolean],
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() { },
  methods: {
    onChange(e) {
      let vm = this;
      vm.$emit("input", e.target.checked);
      vm.$emit("change", e);
    },
  },
};
</script>
<style lang="scss" scoped>
/* The checkbox-container */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 18px;
  padding-top: 1px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: all 0.2s ease;
  color: #2c3e50;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 12px;
  width: 12px;
  background-color: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 3px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input~.checkmark {
  border-color: #0085ff;
  background-color: rgba(0, 133, 255, 0.05);
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked~.checkmark {
  background-color: #0085ff;
  border-color: #0085ff;
  transform: scale(1.05);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  transition: all 0.2s ease;
}

/* Show the checkmark when checked */
.checkbox-container input:checked~.checkmark:after {
  display: block;
  animation: checkmark 0.2s ease-in-out;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 4px;
  top: 1px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

@keyframes checkmark {
  0% {
    opacity: 0;
    transform: rotate(45deg) scale(0.8);
  }

  100% {
    opacity: 1;
    transform: rotate(45deg) scale(1);
  }
}

.checkbox-container:active .checkmark {
  transform: scale(0.95);
}

.checkbox-container input:disabled~.checkmark {
  background-color: #f7fafc;
  border-color: #edf2f7;
  cursor: not-allowed;
}

.checkbox-container input:disabled~.checkmark:after {
  border-color: #cbd5e0;
}
</style>
